import React from 'react';
import ResultPanel from '../components/result-panel/result-panel';
import {IGameOrder} from '../result.type';
import {getIGameLastOrder} from '../result-service';
import {View, Image, StyleSheet} from 'react-native';
import {useTranslation} from 'react-i18next';
import Text from '@/components/basic/text';
import globalStore from '@/services/global.state';
import theme from '@/style';
import LazyImage from '@/components/basic/image';
import {goTo, toPriceStr} from '@/utils';
import {NativeTouchableOpacity} from '@/components/basic/touchable-opacity';
import {downIcon} from '@/common-pages/rebate/rebate.variables';
import {currentBrand} from '@/brands';

const ScratchDraw = ({
  onVisibleChange,
}: {
  onVisibleChange?: (visible: boolean) => void;
}) => {
  const [scratchOrder, setScratchOrder] = React.useState<IGameOrder>();
  const {t} = useTranslation();
  const isAnna = currentBrand.key === 'anna';

  const getResult = async () => {
    try {
      const res = await getIGameLastOrder(1);
      setScratchOrder(res);
    } finally {
    }
  };

  React.useEffect(() => {
    if (globalStore.token) {
      getResult();
    } else {
      setScratchOrder(undefined);
    }
  }, []);

  React.useEffect(() => {
    onVisibleChange?.(!!scratchOrder?.orderId);
  }, [onVisibleChange, scratchOrder?.orderId]);

  return scratchOrder?.orderId ? (
    <ResultPanel
      onMore={() => goTo('Bets', {tag: 'Scratch off'})}
      betTime={scratchOrder.orderTime}
      isWin={scratchOrder.orderWinAmount > 0}
      winAmount={scratchOrder.orderWinAmount}>
      <View style={[theme.padding.lrl, theme.padding.tops]}>
        <Text textAlign="center" accent style={styles.sectionTitle}>
          {t('game-page.label.myBets')}
        </Text>
        <View style={[theme.flex.row, theme.padding.tbs]}>
          <LazyImage
            width={48}
            height={48}
            radius={6}
            imageUrl={scratchOrder.gameIcon}
            occupancy="transparent"
          />
          <View
            style={[
              theme.flex.flex1,
              theme.flex.row,
              theme.flex.centerByCol,
              theme.flex.between,
              theme.margin.leftl,
            ]}>
            <View>
              <Text fontFamily="fontInterBold" size="medium" main>
                {scratchOrder.gameName}
              </Text>
              <Text
                style={[theme.margin.topxxs]}
                fontFamily="fontDinBold"
                main
                size="small">
                {toPriceStr(scratchOrder.orderPrice)} x
                {scratchOrder.orderNumber}
              </Text>
            </View>
            <View style={[theme.flex.alignEnd]}>
              <Text
                fontFamily="fontInterBold"
                size="small"
                color="#7F8896"
                style={styles.wonLabel}>
                Won
              </Text>
              <Text
                color={scratchOrder.orderWinAmount > 0 ? '#F15802' : '#000'}
                fontFamily="fontInterBold"
                size="small">
                {toPriceStr(scratchOrder.orderWinAmount, {fixed: 1})}
              </Text>
            </View>
          </View>
        </View>
        <View style={[styles.listWrap]}>
          {scratchOrder.orderList?.slice(0, 3).map((item, _i) => (
            <View
              key={_i}
              style={[
                theme.flex.row,
                theme.flex.between,
                theme.padding.s,
                theme.borderRadius.m,
                styles.orderItem,
                isAnna && styles.annaOrderItem,
              ]}>
              <Text fontFamily="fontInterBold" size="small" color="#7F8896">
                ID:{item.cardId}
              </Text>
              <View style={[theme.flex.row, theme.flex.centerByCol]}>
                {item.status !== 2 ? (
                  <Text size="small" color="#191919">
                    Won
                  </Text>
                ) : null}
                <Text
                  style={[theme.margin.leftxxs]}
                  color={item.winAmount > 0 ? '#F15802' : '#000'}
                  size="small"
                  fontFamily="fontDinBold">
                  {item.status === 2
                    ? 'Unused'
                    : toPriceStr(item.winAmount, {fixed: 1})}
                </Text>
              </View>
            </View>
          ))}
        </View>
        {scratchOrder.orderList && scratchOrder.orderList?.length > 3 && (
          <NativeTouchableOpacity
            onPress={() => {
              goTo('ScratchResultDetail', {
                scratchOrder: JSON.stringify(scratchOrder),
              });
            }}
            style={[
              theme.flex.row,
              theme.flex.centerByCol,
              theme.flex.between,
              theme.padding.tbs,
              styles.viewAll,
              isAnna && styles.annaViewAll,
            ]}>
            <Text fontFamily="fontInterBold" size="small" color="#7F8896">
              View All
            </Text>
            <View style={[theme.margin.leftxxs, styles.moreIconWrap]}>
              <Image source={downIcon} style={[theme.icon.xs]} />
            </View>
          </NativeTouchableOpacity>
        )}
      </View>
    </ResultPanel>
  ) : null;
};

const styles = StyleSheet.create({
  sectionTitle: {
    marginBottom: 2,
    fontWeight: '500',
    fontSize: 12,
  },
  orderItem: {
    backgroundColor: '#F4F5F8',
  },
  annaOrderItem: {
    borderRadius: 8,
  },
  wonLabel: {
    marginBottom: 2,
  },
  listWrap: {
    rowGap: theme.paddingSize.xxs / 2,
  },
  viewAll: {
    marginTop: 4,
  },
  annaViewAll: {
    minHeight: 32,
    paddingTop: 8,
    paddingBottom: 8,
  },
  moreIconWrap: {
    transform: [
      {
        rotate: '-90deg',
      },
    ],
  },
});

export default ScratchDraw;
